import {
  COMMON_SAVE_LEAD_DATA_FOR_CATALOG_BEGIN,
  COMMON_SAVE_LEAD_DATA_FOR_CATALOG_SUCCESS,
  COMMON_SAVE_LEAD_DATA_FOR_CATALOG_FAILURE,
  COMMON_SAVE_LEAD_DATA_FOR_CATALOG_DISMISS_ERROR,
  COMMON_SAVE_LEAD_DATA_FOR_CATALOG_CLEAN,
} from './constants'

export function saveLeadDataForCatalog(leadData) {
  return async (dispatch) => {
    dispatch({
      type: COMMON_SAVE_LEAD_DATA_FOR_CATALOG_BEGIN,
    })
    try {
          dispatch({
              type: COMMON_SAVE_LEAD_DATA_FOR_CATALOG_SUCCESS,
              data: leadData
          })
     } catch (error) {
        dispatch({
          type: COMMON_SAVE_LEAD_DATA_FOR_CATALOG_FAILURE,
          data: { error },
        })
    }
  }
}

export function dismissSaveLeadDataForCatalogError() {
  return {
    type: COMMON_SAVE_LEAD_DATA_FOR_CATALOG_DISMISS_ERROR,
  }
}

export function cleanSaveLeadDataForCatalog() {
  return {
    type: COMMON_SAVE_LEAD_DATA_FOR_CATALOG_CLEAN,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SAVE_LEAD_DATA_FOR_CATALOG_BEGIN:
      return {
        ...state,
        saveLeadDataForCatalogPending: true,
      }

    case COMMON_SAVE_LEAD_DATA_FOR_CATALOG_SUCCESS:
      return {
        ...state,
        saveLeadDataForCatalogPending: false,
        saveLeadDataForCatalogError: false,
        leadDataForCatalog: action.data,
      }

    case COMMON_SAVE_LEAD_DATA_FOR_CATALOG_FAILURE:
      return {
        ...state,
        saveLeadDataForCatalogPending: false,
        saveLeadDataForCatalogError: action.data.error,
      }

    case COMMON_SAVE_LEAD_DATA_FOR_CATALOG_DISMISS_ERROR:
      return {
        ...state,
        saveLeadDataForCatalogError: false,
      }

    case COMMON_SAVE_LEAD_DATA_FOR_CATALOG_CLEAN:
      return {
        ...state,
        saveLeadDataForCatalogPending: false,
        saveLeadDataForCatalogError: false,
        leadDataForCatalog: {},
      }

    default:
      return state
  }
}
